/**
 * Route Configuration
 * Centralized route constants for easy reference
 * Reference: ITL 03-Frontend-Architecture-Components.md section 5
 */

export const ROUTES = {
  // Public Routes
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password/:token',
  VERIFY_EMAIL: '/verify-email/:token',
  ABOUT: '/about',
  CONTACT: '/contact',
  FREE_GAMES: '/free-games',
  
  // Student Routes
  STUDENT: {
    ROOT: '/student',
    DASHBOARD: '/student/dashboard',
    COURSES: '/student/courses',
    COURSE_DETAIL: '/student/courses/:courseId',
    LESSONS: '/student/lessons',
    LESSON_DETAIL: '/student/lessons/:lessonId',
    // Game Routes (CodeCombat-style)
    GAME_WORLD: '/student/game/world/:courseId',
    GAME_LESSON: '/student/game/lesson/:lessonId',
    CHALLENGES: '/student/challenges',
    CHALLENGE_DETAIL: '/student/challenges/:challengeId',
    SUBMISSIONS: '/student/submissions',
    SUBMISSION_DETAIL: '/student/submissions/:submissionId',
    PROGRESS: '/student/progress',
    ACHIEVEMENTS: '/student/achievements',
    LEADERBOARD: '/student/leaderboard',
    PROFILE: '/student/profile',
    SETTINGS: '/student/settings',
  },

  // Teacher Routes
  TEACHER: {
    ROOT: '/teacher',
    DASHBOARD: '/teacher/dashboard',
    CLASSES: '/teacher/classes',
    CLASS_DETAIL: '/teacher/classes/:classId',
    COURSES: '/teacher/courses',
    COURSE_CREATE: '/teacher/courses/create',
    COURSE_EDIT: '/teacher/courses/:courseId/edit',
    CHALLENGES: '/teacher/challenges',
    CHALLENGE_CREATE: '/teacher/challenges/create',
    CHALLENGE_EDIT: '/teacher/challenges/:challengeId/edit',
    GRADING: '/teacher/grading',
    GRADING_DETAIL: '/teacher/grading/:submissionId',
    ASSIGNMENTS: '/teacher/assignments',
    ASSIGNMENT_CREATE: '/teacher/assignments/create',
    ASSIGNMENT_DETAIL: '/teacher/assignments/:assignmentId',
    ANALYTICS: '/teacher/analytics',
    STUDENTS: '/teacher/students',
    STUDENT_DETAIL: '/teacher/students/:studentId',
    PROFILE: '/teacher/profile',
    SETTINGS: '/teacher/settings',
  },

  // Admin Routes
  ADMIN: {
    ROOT: '/admin',
    DASHBOARD: '/admin/dashboard',
    USERS: '/admin/users',
    USER_DETAIL: '/admin/users/:userId',
    COURSES: '/admin/courses',
    COURSE_DETAIL: '/admin/courses/:courseId',
    SYSTEM: '/admin/system',
    ANALYTICS: '/admin/analytics',
    SETTINGS: '/admin/settings',
  },

  // Error Pages
  NOT_FOUND: '/404',
  UNAUTHORIZED: '/unauthorized',
  SERVER_ERROR: '/500',
};

export default ROUTES;

